var map = {
	"./Inter-Black.woff2": 17459,
	"./Inter-BlackItalic.woff2": 11399,
	"./Inter-Bold.woff2": 83195,
	"./Inter-BoldItalic.woff2": 1599,
	"./Inter-ExtraBold.woff2": 78245,
	"./Inter-ExtraBoldItalic.woff2": 92317,
	"./Inter-ExtraLight.woff2": 29296,
	"./Inter-ExtraLightItalic.woff2": 23124,
	"./Inter-Italic.woff2": 99802,
	"./Inter-Light.woff2": 15950,
	"./Inter-LightItalic.woff2": 52702,
	"./Inter-Medium.woff2": 70567,
	"./Inter-MediumItalic.woff2": 67323,
	"./Inter-Regular.woff2": 39294,
	"./Inter-SemiBold.woff2": 83325,
	"./Inter-SemiBoldItalic.woff2": 12773,
	"./Inter-Thin.woff2": 69923,
	"./Inter-ThinItalic.woff2": 20119,
	"./Inter-italic.var.woff2": 22615,
	"./Inter-roman.var.woff2": 60792,
	"./Inter.var.woff2": 56144
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95623;